import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["player", "description"]

  showDescription() {
    this.playerTarget.hidden = true
    this.descriptionTarget.hidden = false
  }

  showPlayer() {
    this.descriptionTarget.hidden = true
    this.playerTarget.hidden = false
  }
}
